"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _UIDropdown = _interopRequireDefault(require("./UIDropdown"));

var _UITypeahead = _interopRequireDefault(require("../typeahead/UITypeahead"));

var _ButtonConstants = require("../button/ButtonConstants");

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _OptionTypes = require("../types/OptionTypes");

var UIDropdownSelect =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UIDropdownSelect, _Component);

  function UIDropdownSelect() {
    (0, _classCallCheck2.default)(this, UIDropdownSelect);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIDropdownSelect).apply(this, arguments));
  }

  (0, _createClass2.default)(UIDropdownSelect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          options = _this$props.options,
          placeholder = _this$props.placeholder,
          searchable = _this$props.searchable,
          onSearchChange = _this$props.onSearchChange,
          value = _this$props.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["onChange", "options", "placeholder", "searchable", "onSearchChange", "value"]);
      var selectedOption;
      options.forEach(function (option) {
        if (option.value === value && !selectedOption) {
          selectedOption = option;
        }

        if (process.env.NODE_ENV !== 'production' && option.options) {
          _devLogger.default.warn({
            message: 'UIDropdownSelect: The given `options` include groups, which are not supported. ' + 'Use `UISelect` instead.',
            key: 'UIDropdownSelect-groups',
            url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/6467'
          });
        }
      });
      return _react.default.createElement(_UIDropdown.default, (0, _extends2.default)({}, rest, {
        buttonText: selectedOption ? selectedOption.text : (0, _lazyEval.default)(placeholder)
      }), _react.default.createElement(_UITypeahead.default, {
        resultsClassName: "p-y-0" // the default padding is redundant in a UIDropdown
        ,
        minimumSearchCount: searchable ? 0 : Infinity,
        onChange: onChange,
        onSearchChange: onSearchChange,
        options: options
      }));
    }
  }]);
  return UIDropdownSelect;
}(_react.Component);

UIDropdownSelect.propTypes = {
  buttonClassName: _propTypes.default.string,
  buttonUse: _propTypes.default.oneOf(Object.keys(_ButtonConstants.USE_CLASSES)).isRequired,
  onChange: _propTypes.default.func,
  onSearchChange: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_OptionTypes.OptionType).isRequired,
  placeholder: (0, _createLazyPropType.default)(_propTypes.default.string).isRequired,
  searchable: _propTypes.default.bool.isRequired,
  value: _OptionTypes.SingleValueType
};
UIDropdownSelect.defaultProps = {
  buttonClassName: 'p-x-2',
  buttonUse: 'transparent',
  placeholder: function placeholder() {
    return _I18n.default.text('salesUI.UIDropdownSelect.placeholder');
  },
  searchable: false
};
UIDropdownSelect.displayName = 'UIDropdownSelect';

var _default = (0, _Controllable.default)(UIDropdownSelect, ['open', 'value']);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/dropdown/UIDropdownSelect.js
// module id = 685
// module chunks = 5 6